/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-25 14:14:50
 * @LastEditTime: 2024-03-01 15:14:15
 * @Descripttion: file content
 */
const commAction = {
	/**
	 * 设置token
	 */
	SET_TOKEN: 'set_token',
	/**
	 * 获取模块信息
	 */
	GET_APP_CONF_MODULE: 'get_app_conf_module',
	/**
	 * 更新模块信息
	 */
	UPDATE_APP_CONF_MODULE: 'update_app_conf_module',
	/**
	 * 重置comm状态
	 */
	RESET_COMM_STORE: 'reset_comm_store',
	/**
	 * 学段(1，小学，2，初中，3高中，4大学)
	 */
	PERIOD_Id: 'period_id'
}

export default commAction
